// src/context/LoadingManager.ts
import { EventEmitter } from 'events';

class LoadingManager extends EventEmitter {
  private isLoading: boolean = false;

  setLoading(status: boolean) {
    this.isLoading = status;
    this.emit('loadingChange', this.isLoading);
  }

  getLoading() {
    return this.isLoading;
  }
}

const loadingManager = new LoadingManager();

export default loadingManager;
